import { Component, inject, signal } from '@angular/core';
import { PartTabsComponent } from '../parts/part-tabs.component';
import { Part } from '../core/models/part';
import { PartsService } from '../core/parts.service';

@Component({
    selector: 'app-featured-parts',
    template: `
        <div class="page home-page">
            <div class="page-body">
                <app-part-tabs [parts]="parts()" [pageSize]="8" />
            </div>
        </div>
    `,
    styles: ``,
    imports: [PartTabsComponent]
})
export class FeaturedPartsComponent {
    partsService = inject(PartsService);
    parts = signal<Part[]>([]);

    async ngOnInit() {
        let parts = await this.partsService.getParts({ hasPictures: true, isFeatured: true, hasPrice: true, take: 8 });
        this.parts.set(parts);
    }
}
